import { useAppStore } from "@/store/modules/app";
import { showDialog } from "@/utils/app";

/** 上次 401 处理时间戳：冷却期内跳过，防止并发 401 重复弹错误提示、重复登出跳转 */
let lastUnauthorizedAt = 0;

export function errorHandle(code: number, message: string) {
  const handleMap = {
    401: async (msg: string) => {
      if (Date.now() - lastUnauthorizedAt < 2000) return;
      lastUnauthorizedAt = Date.now();
      window.$message?.error(msg || "网络错误，请重试！");
      useAppStore()?.logout();
    },
    403: async (msg: string) => {
      window.$message?.error(msg || "网络错误，请重试！");
      // useAppStore()?.logout();
    },
    5300001: async (msg: string) => {
      showDialog({
        type: "warning",
        title: "无法退出联盟！",
        content:
          "您是联盟中唯一的管理员，请先转让管理员权限给其他成员，再尝试退出。",
        positiveText: "知道了",
        negativeText: "",
      });
    },
    5100023: async (msg: string) => {
      // window.$message?.warning(msg || '网络错误，请重试！', {
      //   duration: 5000,
      // });
      showDialog({
        type: "warning",
        title: "提示",
        content:
          "系统正在处理您提交的数据，数据量较大，可能需要几分钟，您可以刷新页面查看已提交成功的数据",
        positiveText: "知道了",
        negativeText: "",
      });
    },
    default: (msg: string) => {
      window.$message?.error(msg || "网络错误，请重试！");
    },
  };

  if (Object.hasOwn(handleMap, code)) {
    (handleMap as any)[code](message);
  } else {
    handleMap.default(message);
  }
}
